import { EmailTemplatesWrapper } from '../../components'

export default function EmailTemplatesPage() {
  return (
    <>
      <EmailTemplatesWrapper />
    </>
  )
}
